import { reportAPI } from '@/services-ts/axios'
import type {
  IDateRange,
  IGetDistributablePointReport,
  IGetDistributablePointReportExcel,
  IGetPointResetReport,
  IGetPostBasedDetailedReport,
  IGetSpendablePointReport,
  IGetSpendablePointReportExcel,
} from '@/types/Request'
import { defineStore } from 'pinia'

export const usePointReportStore = defineStore('pointReport', {
  actions: {
    /* async GetPointReport(payload) {
      const response = await reportAPI.PointReportServices.GetPointReport(payload);
      return response.data.data;
    }, */

    async GetPostDetailReport(payload: IGetPostBasedDetailedReport) {
      const { status, data, total } =
        await reportAPI.PointReportServices.GetPostDetailReport(payload)
      return status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    async GetSpendablePointReport(payload: IGetSpendablePointReport) {
      const { status, data, total } =
        await reportAPI.PointReportServices.GetSpendablePointReport(payload)
      return status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    async GetDistributablePointReport(payload: IGetDistributablePointReport) {
      const { status, data, total } =
        await reportAPI.PointReportServices.GetDistributablePointReport(payload)
      return status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    async GetPointResetReport(payload: IGetPointResetReport) {
      const { status, data, total } =
        await reportAPI.PointReportServices.GetPointResetReport(payload)
      return status ? { data, total: total || 0 } : { data: [], total: 0 }
    },

    /* async GetPointReportExcel(payload) {
      await reportAPI.PointReportServices.GetPointReportExcel(payload);
    }, */

    async GetPostDetailReportExcel(payload: IDateRange) {
      await reportAPI.PointReportServices.GetPostDetailReportExcel(payload)
    },

    async GetSpendablePointReportExcel(payload: IGetSpendablePointReportExcel) {
      await reportAPI.PointReportServices.GetSpendablePointReportExcel(payload)
    },

    async GetSpendablePointReportDetailExcel(payload: IGetSpendablePointReportExcel) {
      await reportAPI.PointReportServices.GetSpendablePointReportDetailExcel(payload)
    },

    async GetDistributablePointReportExcel(payload: IGetDistributablePointReportExcel) {
      await reportAPI.PointReportServices.GetDistributablePointReportExcel(payload)
    },

    async GetDistributablePointReportDetailExcel(payload: IGetDistributablePointReportExcel) {
      await reportAPI.PointReportServices.GetDistributablePointReportDetailExcel(payload)
    },

    async GetPointResetReportExcel(payload: IGetPointResetReport) {
      await reportAPI.PointReportServices.GetPointResetReportExcel(payload)
    },
  },
})
